import React from 'react';
import Accordion from './Accordion';
import LabelWithOption from './LabelWithOption';

const RenderAccordion = ({ name, disabled, permissions }) => {
	const renderChildren = () => {
		return permissions[name].children.map((e) => {
			if (permissions[e] !== null && permissions[e] !== undefined) {
				if (permissions[e].type === 'child') {
					return (
						<LabelWithOption
							smallLabel={true}
							text={permissions[e].label ? permissions[e].label : e}
							id={e}
							options={permissions[e].options}
							disabled={disabled}
						/>
					);
				} else if (
					permissions[e].type === 'sub-parent' ||
					permissions[e].type === 'accordion-child'
				) {
					return <RenderAccordion permissions={permissions} name={e} />;
				}
			}
			return <div></div>;
		});
	};

	return (
		<Accordion
			disabled={disabled}
			id={name}
			title={permissions[name].label ? permissions[name].label : name}
			headerOptions={permissions[name].headerOptions}
			bodyOptions={permissions[name].options}
		>
			{permissions &&
				permissions[name] &&
				permissions[name].children &&
				renderChildren()}
		</Accordion>
	);
};

const CommonPermission = (props) => {
	const { permissions, disabled } = props;
	return Object.keys(permissions).map((e) => {
		if (permissions[e].type === 'accordion') {
			return (
				<Accordion
					id={e}
					title={e}
					disabled={disabled}
					headerOptions={permissions[e].headerOptions}
					bodyOptions={permissions[e].options}
				/>
			);
		} else if (permissions[e].type === 'parent') {
			return (
				<RenderAccordion
					disabled={disabled}
					permissions={permissions}
					name={e}
				/>
			);
		} else if (permissions[e].type === 'single') {
			return (
				<LabelWithOption
					disabled={disabled}
					id={e}
					text={e}
					options={permissions[e].options}
				/>
			);
		}
		return;
	});
};

CommonPermission.propTypes = {};

export default CommonPermission;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/CommonPermission/index.jsx